<app-transactions-dialog-component
  [refillData]="refillData"
  (oncloseDialog)="closeModal()"
>
</app-transactions-dialog-component>
